import { Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router';

import { parsePalletCode } from '@/lib/pallets';

/** Ссылка из QR этикетки `/p/SWP-12-3` → карточка партии в «Остатках». */
export function PalletLink() {
  const { t } = useTranslation();
  const { code = '' } = useParams();
  const ref = parsePalletCode(code);
  if (!ref) return <Result status="warning" title={t('labels.badCode', { code })} />;
  return <Navigate to={`/stock?batch=${ref.batchId}&pallet=${ref.palletNo}`} replace />;
}
